import { r as s, c as t } from "./main-bb89b2f2.js";
import { u as r } from "./unique-id-1206d8f1-53216113.js";
import "vue";
const a = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.static{position:static}", i = a, o = class {
  constructor(e) {
    s(this, e), this.storytabsItemLabelChange = t(this, "lhStorytabsItemLabelChange", 7), this.storytabsItemDisabledChange = t(this, "lhStorytabsItemDisabledChange", 7), this.storytabsItemSuccessChange = t(this, "lhStorytabsItemSuccessChange", 7), this.storytabsItemErrorChange = t(this, "lhStorytabsItemErrorChange", 7), this.label = "", this.active = !1, this.disabled = !1, this.success = !1, this.error = !1, this.value = r();
  }
  storytabsItemLabelWatcher() {
    this.storytabsItemLabelChange.emit();
  }
  storytabsItemDisabledWatcher() {
    this.storytabsItemDisabledChange.emit();
  }
  storytabsItemSuccessWatcher() {
    this.storytabsItemSuccessChange.emit();
  }
  storytabsItemErrorWatcher() {
    this.storytabsItemErrorChange.emit();
  }
  static get watchers() {
    return {
      label: ["storytabsItemLabelWatcher"],
      disabled: ["storytabsItemDisabledWatcher"],
      success: ["storytabsItemSuccessWatcher"],
      error: ["storytabsItemErrorWatcher"]
    };
  }
};
o.style = i;
export {
  o as patternlib_storytabs_item
};
